module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hint":"Get more information"}}')
  delete Component.options._Ctor
}
